import { useRef, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import axios from "axios";

import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { BarrioContext } from "../components/BarrioContext";
import { useAuth } from "../components/AuthContext";

import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';

const Fondos = () => {
    const toast = useRef(null);
    const HOST_API = process.env.REACT_APP_URL;
    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);

    // â”€â”€â”€ Helpers compartidos â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const camelToHeader = (key) =>
        key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();

    const formatValue = (value, type) => {
        if (value === null || value === undefined) return "";
        switch (type) {
            case "date":
                return new Date(value).toLocaleDateString("es-AR");
            case "currency":
                return typeof value === "number"
                    ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
                    : value;
            default:
                return typeof value === "object" ? JSON.stringify(value) : value;
        }
    };

    const activoBadge = (row) => {
        const s = row.activo
            ? { bg: '#ecfdf3', color: '#12b76a', border: '#a9efc5', label: 'Activo' }
            : { bg: '#fef3f2', color: '#f04438', border: '#fecdca', label: 'No Activo' };
        return (
            <span style={{
                background: s.bg, color: s.color, border: `1px solid ${s.border}`,
                fontWeight: 600, fontSize: '0.75rem', padding: '0.15rem 0.6rem', borderRadius: 99,
            }}>
                {s.label}
            </span>
        );
    };

    const flattenRow = (row) => {
        const flat = {};
        for (const [key, value] of Object.entries(row)) {
            if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
                for (const [nestedKey, nestedValue] of Object.entries(value)) {
                    flat[nestedKey] = nestedValue;
                    flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
                }
            } else {
                flat[key] = value;
            }
        }
        return flat;
    };

    // â”€â”€â”€ SecciÃ³n 1: Fondo â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const initialFormDataFondo = {
        fondoId: 0,
        nombre: "",
        descripcion: "",
        activo: true,
    };

    const [formDataFondo, setFormDataFondo] = useState(initialFormDataFondo);
    const [visibleFondo, setVisibleFondo] = useState(false);
    const [fondos, setFondos] = useState([]);

    const handleChangeFondo = (campo, valor) => {
        setFormDataFondo((prev) => ({ ...prev, [campo]: valor }));
    };

    const handleSubmitFondo = async (e) => {
        e.preventDefault();
        const payload = {
            ...formDataFondo,
            administracionId,
        };
        try {
            await axios.post(`${HOST_API}api/fondos/SaveFondo`, payload);
            setVisibleFondo(false);
            fetchFondos();
        } catch (err) {
            console.error(err);
        }
    };

    const fetchFondos = useCallback(async () => {
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(`${HOST_API}api/fondos/GetFondos?fondoId=0&administracionId=${administracionId}`);
            console.log(response.data);
            setFondos(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener fondos");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [administracionId]);

    useEffect(() => {
        fetchFondos();
    }, [fetchFondos]);

    const fondosFlat = useMemo(() => fondos?.map(flattenRow) ?? [], [fondos]);

    const columnsFondo = useMemo(() => {
        if (!fondosFlat?.length) return [];
        const firstRow = fondosFlat[0];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type") && key !== 'administracionId' && key !== 'razonSocial' && key !== 'activo')
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: camelToHeader(field),
            }));
    }, [fondos]);

    // â”€â”€â”€ SecciÃ³n 2: Fondo por Barrio â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const initialFormDataFondoPorBarrio = {
        fondoBarrioId: 0,
        fondoId: null,
        porcentaje: "",
        fechaInicio: null,
        fechaFin: null,
        activo: true,
    };

    const [formDataFondoPorBarrio, setFormDataFondoPorBarrio] = useState(initialFormDataFondoPorBarrio);
    const [visibleFondoPorBarrio, setVisibleFondoPorBarrio] = useState(false);
    const [fondosPorBarrio, setFondosPorBarrio] = useState([]);

    const handleChangeFondoPorBarrio = (campo, valor) => {
        setFormDataFondoPorBarrio((prev) => ({ ...prev, [campo]: valor }));
    };

    const handleSubmitFondoPorBarrio = async (e) => {
        e.preventDefault();
        const user = JSON.parse(localStorage.getItem("user"));
        const payload = {
            ...formDataFondoPorBarrio,
            barrioId: barrio.id,
            administracionId,
            usuarioId: user?.id,
        };
        try {
            await axios.post(`${HOST_API}api/fondosporbarrio/SaveFondoPorBarrio`, payload);
            setVisibleFondoPorBarrio(false);
            fetchFondosPorBarrio();
        } catch (err) {
            console.error(err);
        }
    };

    const fetchFondosPorBarrio = useCallback(async () => {
        if (!barrio?.id) return;
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(
                `${HOST_API}api/fondosporbarrio/GetFondosPorBarrio?barrioId=${barrio.id}&administracionId=${administracionId}`
            );
            console.log(response.data);
            setFondosPorBarrio(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener fondos por barrio");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [barrio?.id, administracionId]);

    useEffect(() => {
        fetchFondosPorBarrio();
    }, [fetchFondosPorBarrio]);

    const fondosPorBarrioFlat = useMemo(() => fondosPorBarrio?.map(flattenRow) ?? [], [fondosPorBarrio]);

    const columnsFondoPorBarrio = useMemo(() => {
        if (!fondosPorBarrioFlat?.length) return [];
        const firstRow = fondosPorBarrioFlat[0];
        const EXCLUIR = ['usuario', 'nombreUsuario', 'usuarioNombre', 'razonSocial', 'nombreBarrio', 'barrio', 'barrioNombre', 'activo'];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type") && !EXCLUIR.includes(key))
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: camelToHeader(field),
            }));
    }, [fondosPorBarrio]);

    // â”€â”€â”€ Edit / Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleEditFondo = (row) => {
        setFormDataFondo({ ...initialFormDataFondo, ...row });
        setVisibleFondo(true);
    };

    const handleDeleteFondo = (id) => {
        confirmDialog({
            message: '¿Estás seguro de eliminar este fondo?',
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/fondos/DeleteFondo/${id}`);
                    fetchFondos();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    const handleEditFondoPorBarrio = (row) => {
        setFormDataFondoPorBarrio({
            ...initialFormDataFondoPorBarrio,
            ...row,
            fechaInicio: row.fechaInicio ? new Date(row.fechaInicio) : null,
            fechaFin: row.fechaFin ? new Date(row.fechaFin) : null,
        });
        setVisibleFondoPorBarrio(true);
    };

    const handleDeleteFondoPorBarrio = (id) => {
        confirmDialog({
            message: '¿Estás seguro de eliminar este fondo por barrio?',
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/fondosporbarrio/DeleteFondoPorBarrio/${id}`);
                    fetchFondosPorBarrio();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    // â”€â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    return (
        <>
            <h4>Fondos</h4>
            <br />

            <ConfirmDialog />
            <Toast ref={toast} />
            <Dialog
                visible={loadingBackdrop}
                modal
                closable={false}
                showHeader={false}
                className="backdrop-dialog"
            >
                <ProgressSpinner style={{ width: '60px', height: '60px' }} />
            </Dialog>

            {/* â”€â”€ SecciÃ³n 1: Fondo â”€â”€ */}

            <h5>Fondo</h5>

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label="Nuevo Fondo"
                    icon="pi pi-plus"
                    onClick={() => { setFormDataFondo(initialFormDataFondo); setVisibleFondo(true); }}
                />
            </div>

            <Dialog
                header="Fondo"
                visible={visibleFondo}
                style={{ width: "50vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisibleFondo(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmitFondo}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full md:w-6">
                                <label>Nombre</label>
                                <InputText
                                    type="text"
                                    value={formDataFondo.nombre || ""}
                                    onChange={(e) => handleChangeFondo("nombre", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full">
                                <label>Descripción</label>
                                <InputText
                                    type="text"
                                    value={formDataFondo.descripcion || ""}
                                    onChange={(e) => handleChangeFondo("descripcion", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full flex align-items-center gap-2 mt-2">
                                <Checkbox
                                    inputId="activoFondo"
                                    checked={!!formDataFondo.activo}
                                    onChange={(e) => handleChangeFondo("activo", e.checked)}
                                />
                                <label htmlFor="activoFondo">Activo</label>
                            </div>

                            <div className="col-12 mt-3">
                                <Button label="Guardar" icon="pi pi-save" type="submit" />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <div className="grid mb-5">
                <div className="col-12">
                    <DataTable
                        value={fondosFlat}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay fondos cargados"
                        style={{ fontSize: '0.88rem' }}
                    >
                        {columnsFondo.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Estado"
                            style={{ width: '8rem' }}
                            body={activoBadge}
                        />
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEditFondo(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDeleteFondo(row.fondoId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>

            {/* â”€â”€ SecciÃ³n 2: Fondo por Barrio â”€â”€ */}

            <h5>Fondo por Barrio</h5>

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label="Nuevo Fondo por Barrio"
                    icon="pi pi-plus"
                    onClick={() => { setFormDataFondoPorBarrio(initialFormDataFondoPorBarrio); setVisibleFondoPorBarrio(true); }}
                />
            </div>

            <Dialog
                header="Fondo por Barrio"
                visible={visibleFondoPorBarrio}
                style={{ width: "70vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisibleFondoPorBarrio(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmitFondoPorBarrio}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full md:w-4">
                                <label>Fondo</label>
                                <Dropdown
                                    value={formDataFondoPorBarrio.fondoId}
                                    options={fondos}
                                    optionLabel="nombre"
                                    optionValue="fondoId"
                                    onChange={(e) => handleChangeFondoPorBarrio("fondoId", e.value)}
                                    placeholder="Seleccioná un fondo"
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Porcentaje</label>
                                <InputText
                                    type="number"
                                    step="0.01"
                                    value={formDataFondoPorBarrio.porcentaje || ""}
                                    onChange={(e) => handleChangeFondoPorBarrio("porcentaje", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Fecha inicio</label>
                                <Calendar
                                    value={formDataFondoPorBarrio.fechaInicio}
                                    dateFormat="dd/mm/yy"
                                    onChange={(e) => handleChangeFondoPorBarrio("fechaInicio", e.value)}
                                    showIcon
                                    className="p-inputtext-sm"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Fecha fin</label>
                                <Calendar
                                    value={formDataFondoPorBarrio.fechaFin}
                                    dateFormat="dd/mm/yy"
                                    onChange={(e) => handleChangeFondoPorBarrio("fechaFin", e.value)}
                                    showIcon
                                    className="p-inputtext-sm"
                                />
                            </div>

                            <div className="w-full md:w-4 flex align-items-center gap-2 mt-2">
                                <Checkbox
                                    inputId="activo"
                                    checked={formDataFondoPorBarrio.activo}
                                    onChange={(e) => handleChangeFondoPorBarrio("activo", e.checked)}
                                />
                                <label htmlFor="activo">Activo</label>
                            </div>

                            <div className="col-12 mt-3">
                                <Button label="Guardar" icon="pi pi-save" type="submit" />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <div className="grid">
                <div className="col-12">
                    <DataTable
                        value={fondosPorBarrioFlat}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay fondos por barrio cargados"
                        style={{ fontSize: '0.88rem' }}
                    >
                        {columnsFondoPorBarrio.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Estado"
                            style={{ width: '8rem' }}
                            body={activoBadge}
                        />
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEditFondoPorBarrio(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDeleteFondoPorBarrio(row.fondoBarrioId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default Fondos;
